export const scrollToTop = (options?: ScrollToOptions) => {
  window.scrollTo({ top: 0, ...options });
};
